module.exports = __webpack_public_path__ + "img/close.3c46ef1c.svg";